export default {
    LOADING: 'GIS_MAP_LOADING',
    DATA_LOADED: 'GIS_MAP_LOADED',
    LINKEDDATA_LOADED: 'GIS_MAP_NEXTLOADED',
    FILTER_CHANGED: 'GIS_MAP_FILTER_CHANGED',
    AUXDRAWINGS_CHANGED: 'GIS_MAP_AUXDRAWINGS_CHANGED',
    DATE_FILTER_CHANGED: 'GIS_MAP_DATE_FILTER_CHANGED',
    TOGGLE_FILTER: 'TOGGLE_FILTER',
    DISPLAY_MODE_CHANGED: 'GIS_MAP_DISPLAY_MODE_CHANGED',
    ZOOM_CHANGED: 'GIS_MAP_ZOOM_CHANGED'
}


// WEBPACK FOOTER //
// ./App/components/modules/gis-map/action-types.js